var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "id-card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Light",
    opacity: 0.2,
    d: "M1.83301 6C1.83301 4.34315 3.17615 3 4.83301 3H13.833C15.4899 3 16.833 4.34315 16.833 6V12C16.833 13.6569 15.4899 15 13.833 15H4.83301C3.17615 15 1.83301 13.6569 1.83301 12V6Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 7.5C7.83301 6.67157 7.16143 6 6.33301 6C5.50458 6 4.83301 6.67157 4.83301 7.5C4.83301 8.32843 5.50458 9 6.33301 9C5.37157 9 4.53213 9.6033 4.08301 10.5C4.08301 10.9142 4.41879 11.25 4.83301 11.25H7.83301C8.24722 11.25 8.58301 10.9142 8.58301 10.5C8.13389 9.6033 7.29445 9 6.33301 9C7.16143 9 7.83301 8.32843 7.83301 7.5Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 7.3125C9.33301 7.00184 9.58485 6.75 9.89551 6.75H13.6455C13.9562 6.75 14.208 7.00184 14.208 7.3125C14.208 7.62316 13.9562 7.875 13.6455 7.875H9.89551C9.58485 7.875 9.33301 7.62316 9.33301 7.3125Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 9.375C9.33301 9.06434 9.58485 8.8125 9.89551 8.8125H11.3955C11.7062 8.8125 11.958 9.06434 11.958 9.375C11.958 9.68566 11.7062 9.9375 11.3955 9.9375H9.89551C9.58485 9.9375 9.33301 9.68566 9.33301 9.375Z",
    fill: "#6B47F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.af164345c16a92d619df7eb78a926108.svg";
export { ForwardRef as ReactComponent };